<template>
  <div v-show="menuList.length != 0">
    <div class="box">
      <div class="left-muen">
        <div
          class="item"
          v-for="(item, index) in menuList"
          :key="item.path"
          :class="item.group.includes($route.path) ? 'active' : ''"
          @click="gotopage(item.path, index)"
        >
          <!-- v-show="!item.hidden" -->
          <i :class="item.source" />
          <p class="second_menu_text">{{ item.name }}</p>
          <!-- <p>{{ item.name }}{{ item.hidden }}===item.hidden</p> -->
        </div>

        <div v-if="route2.name == '综合管理'" class="item" @click="gotopage3()">
          <img
            src="https://edulogin.sanyaedu.org/file/data/icon/2022-05-30/Frame-13D.png"
          />
          <p>3D展示厅</p>
        </div>
      </div>

      <div class="user">
        <el-dropdown :hide-on-click="false" @command="handleCommand">
          <span class="el-dropdown-link">
            <i
              class="el-icon-setting"
              style="font-size: 20px; cursor: pointer"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">退出登录</el-dropdown-item>
            <el-dropdown-item command="b">修改密码</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div class="msg">
          <i class="el-icon-bell" style="font-size: 20px; cursor: pointer"></i>
        </div>
        <div class="info">
          <div class="name">{{ userName }}</div>
          <div class="tx">
            <img src="../assets/menu/logo.png" />
          </div>
        </div>
      </div>
    </div>
    <div
      class="menu2 hkssssssssss"
      v-if="
        menuList &&
        menuList[$store.state.vuex_type] &&
        menuList[$store.state.vuex_type].children &&
        menuList[$store.state.vuex_type].children.length > 0
      "
    >
      <!-- 三级菜单 -->
      <template v-for="(v, i) in menuList[$store.state.vuex_type].children">
        <div
          class="item-m2"
          :class="url == v.path ? 'active2' : ''"
          :key="i"
          @click="gotopage2(v, i)"
          v-if="v.name.indexOf('none') < 0"
        >
          <!-- v-if="!item.hidden" -->
          {{ v.name }}
        </div>
      </template>
    </div>
    <div class="breadcrumb" v-if="path != '/' && breadList.length != 0">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          v-for="(item, index) in breadList"
          :key="index"
          :to="{ path: item.path }"
          >{{ item.name }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
    >
      <span>是否退出登录?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="loginOut">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改密码"
      :visible.sync="updatePasswdDialogVisible"
      width="30%"
      :append-to-body="true"
    >
      <div>
        <el-form ref="update" :model="update" label-width="auto">
          <el-form-item label="输入旧密码">
            <el-input v-model="update.oldPasswd"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="update" :model="update" label-width="auto">
          <el-form-item label="输入新密码">
            <el-input v-model="update.newPasswd"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="update" :model="update" label-width="auto">
          <el-form-item label="确认新密码">
            <el-input v-model="update.newPasswdAgain"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updatePasswdDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="commitUpdatePasswd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
import { delCookieInfos } from "@/utils/util.js";

var user = VueCookies.get("userInfo");

import { http } from "@/request/api";

// import home from "@/assets/menu/1.png";
// import home2 from "@/assets/menu/2.png";
// import home3 from "@/assets/menu/3.png";
// import home4 from "@/assets/menu/4.png";
// import home5 from "@/assets/menu/5.png";
// import home6 from "@/assets/menu/6.png";
// import home7 from "@/assets/menu/7.png";
// import s1 from "@/assets/menu/s1.png";
// import s2 from "@/assets/menu/s2.png";
// import s3 from "@/assets/menu/s3.png";
// import s4 from "@/assets/menu/s4.png";
// import s5 from "@/assets/menu/s5.png";
// import s6 from "@/assets/menu/s6.png";
// import s7 from "@/assets/menu/s7.png";
// import bus from "@/utils/bus";
export default {
  name: "app",
  data() {
    return {
      breadList: [],
      path: "",
      menuList: [],
      url: "",
      userName: user.nickName,
      route2: "",

      dialogVisible: false,
      updatePasswdDialogVisible: false,
      update: {
        oldPasswd: "",
        newPasswd: "",
        newPasswdAgain: "",
      },
    };
  },

  beforeCreate() {
    this.BUS.$on("breadList", (list) => {
      this.breadList = list;
    });
    this.BUS.$on("path", (list) => {
      this.path = list;
    });

    //收到menuList事件
    this.BUS.$on("menuList", (list) => {
      // list.map((item) => {
      //   console.log(item, "itemitemitemitem");
      //   if (item.name.indexOf("-none") > -1) {
      //     list = [];
      //   }
      // });
      // this.menuList = list;

      list.forEach((item, index, list) => {
        if (item.name.indexOf("-none") > -1) {
          list.splice(index, 1);
        }
      });

      this.menuList = list;
    });
  },
  created() {
    console.log(this.$route, "路由");
  },
  methods: {
    handleCommand(command) {
      console.log(command, "handleCommandxxx");
      if (command == "a") {
        this.dialogVisible = true;
      } else if (command == "b") {
        this.updatePasswdDialogVisible = true;
      }
    },

    gotopage3() {
      window.open("https://apph5.sanyaedu.org/dist-test/", "_blank");
    },
    async gotopage(url, i) {
      console.log(url, "path00000000000");
      console.log(i, "path00000000001");
      this.$router.push(url);
      this.$mc.vuex("vuex_type", i);
    },
    gotopage2(v, i) {
      console.log(v.path, "path11111111111");
      this.$router.push(v.path);
    },

    commitUpdatePasswd() {
      console.log("修改密码");
      this.updatePasswdDialogVisible = true;

      if (this.update.oldPasswd == "") {
        this.$message("旧密码不能为空");
        return;
      }

      if (this.update.newPasswd == "") {
        this.$message("新密码不能为空");
        return;
      }

      if (this.update.newPasswdAgain == "") {
        this.$message("确认密码不能为空");
        return;
      }

      if (this.update.oldPasswd == this.update.newPasswd) {
        this.$message("新密码不能跟旧密码重复");
        return;
      }

      if (this.update.newPasswd != this.update.newPasswdAgain) {
        this.$message("新密码跟确认密码不一致");
        return;
      }

      //正则校验 验证字符串必须包括至少1个大写字母，1个小写字母，1个数字和1个特殊字符
      const regex = new RegExp(
        /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*?]).{8,16}$/
      );
      const isValid = regex.test(this.update.newPasswd);

      if (!isValid) {
        this.$message.warning("新设置的密码为8-16位，须包含数字、大、小写字母和特殊字符");
        return;
      }

      http
        .updatePassword(
          this.update.oldPasswd,
          this.update.newPasswd,
          this.update.newPasswdAgain
        )
        .then((res) => {
          http.logOut().then((res) => {
            this.delCookie();
            this.$message.success("修改密码成功,已退出登录");
            window.location.href = process.env.LOGINIURL;
          });
        });
    },

    loginOut() {
      this.dialogVisible = true;
      http.logOut().then((res) => {
        this.delCookie();
        this.$message.success("已退出登录");
        window.location.href = process.env.LOGINIURL;
      });
    },

    delCookie() {
      delCookieInfos();
      // var cookies = document.cookie.split(";");
      // for (var i = 0; i < cookies.length; i++) {
      //   var cookie = cookies[i];
      //   var eqPos = cookie.indexOf("=");
      //   var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      //   document.cookie =
      //     name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      // }
      // if (cookies.length > 0) {
      //   for (var i = 0; i < cookies.length; i++) {
      //     var cookie = cookies[i];
      //     var eqPos = cookie.indexOf("=");
      //     var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      //     var domain = location.host.substr(location.host.indexOf("."));
      //     document.cookie =
      //       name +
      //       "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" +
      //       domain;
      //   }
      // }
    },
  },
  watch: {
    $route: {
      handler: function (route) {
        this.url = route.path;
        console.log(route, "routerouteddd");
        this.route2 = route;
      },
      immediate: true,
    },
    menuList: {
      handler(val) {
        if (val.length != 0) {
          this.gotopage(val[0].url, 0);
        }
        console.log(val, "菜单变化");
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.menu2 {
  margin-top: 20px;
  display: flex;
  align-items: center;

  .active2 {
    color: #0f1741 !important;
  }

  .item-m2 {
    margin-right: 35px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 1px rgba(15, 23, 65, 0.08);
    border-radius: 16px 16px 16px 16px;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #999999;
    font-size: 16px;//三级菜单字体设置为16px
  }
}

.left-muen {
  .item {
    color: #999999;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;

    p {
      margin-top: 5px;
      font-size: 16px;//二级菜单字体设置为20px
    }

    i {
      font-size: 20px;
    }
  }

  display: flex;
  align-items: center;
  justify-content: space-around;
  flex: 1;
  width: 1418px;
  background: #fff;
  height: 100px;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 40px 40px 40px 40px;
  margin-right: 30px;
}

.user {
  .info {
    display: flex;
    align-items: center;

    .name {
      color: #0f1741;
      font-size: 14px;
    }

    .tx {
      margin-left: 12px;
      width: 40px;
      height: 40px;

      img {
        width: 40px;
        height: 40px;
      }
    }
  }

  width: 254px;
  height: 100px;
  background: #ffffff;
  border-radius: 40px 40px 40px 40px;
  opacity: 1;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.breadcrumb {
  margin-top: 30px;
  background: #ffffff;
  box-shadow: 1px 4px 12px 1px rgba(18, 39, 95, 0.05000000074505806);
  border-radius: 8px 8px 8px 8px;
  padding: 12px 25px;
  display: table;
}

.box {
  flex-shrink: 0;

  .active {
    color: #0f1741 !important;
    font-weight: bold;
  }

  width: 100%;
  display: flex;
  align-items: center;
}

.user {
  .info {
    display: flex;
    align-items: center;

    .name {
      color: #0f1741;
      font-size: 14px;
    }

    .tx {
      margin-left: 12px;
      width: 40px;
      height: 40px;

      img {
        width: 40px;
        height: 40px;
      }
    }
  }

  width: 254px;
  height: 100px;
  background: #ffffff;
  border-radius: 40px 40px 40px 40px;
  opacity: 1;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue